import React from 'react';
import { connect } from 'react-redux';
import Loader from 'features/Loader/Loader';
import NutritionList from 'features/nutrition/components/NutritionList';
import NutritionViewHistory from './NutritionViewHistory';
import { getNutritionSummery } from './ducks/nutritionLogsAction';

class NutritionTab extends React.Component {
  componentDidMount() {
    this.props.getNutritionSummery(this.props.clientId);
  }

  render() {
    let { clientId, clientNutrition, loadingNutritionSummery, nutritionSummary } = this.props;
    let { clientNutritionLoading, plans } = clientNutrition;
    if (clientNutritionLoading || loadingNutritionSummery) {
      return(<Loader/>);
    }
    return (
      <>
        <NutritionViewHistory
          clientId={clientId}
          nutritionSummary={nutritionSummary}
        />
        {clientNutrition && (
          <NutritionList
            plans={plans}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    nutritionSummary: state.nutritionLogsReducer.nutritionSummary,
    loadingNutritionSummery: state.nutritionLogsReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNutritionSummery: clientId => dispatch(getNutritionSummery(clientId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NutritionTab);

